export enum AuthType {
  ID = "id",
  IDV = "idv",
}

export enum ServiceOption {
  Verification = "verification",
  CrossCheck = "cross_check",
}
